import { Typography } from "@mui/material"
import { Box } from "@mui/system"
import { useCardHolderContext } from "layouts/card-holder/context/useCardHolderContext.ts"
import { CardHolderPopups } from "layouts/card-holder/popups/cardHolderPopups.tsx"
import { useEffect } from "react"
import { VehicleListWrapper } from "layouts/card-holder/vehicles/VehicleListWrapper.tsx"
import { DataStateHandler } from "components/DataStateHandler.tsx"
import { CardHolderTable } from "layouts/card-holder/table/cardHolderTable.tsx"

export const VehicleContainer = () => {
    const { setIsVehicle, apiSuccess, isLoading, noResultFilter } =
        useCardHolderContext()

    useEffect(() => {
        setIsVehicle(true)
        return () => setIsVehicle(false)
    }, [setIsVehicle])

    return (
        <Box>
            <DataStateHandler
                isLoading={isLoading}
                apiSuccess={apiSuccess}
                noResultFilter={noResultFilter}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "1.5rem",
                    }}
                >
                    <Typography
                        variant="headlineLarge"
                        sx={{ color: "grey.900" }}
                    >
                        Liste des véhicules
                    </Typography>
                    <VehicleListWrapper>
                        <CardHolderTable />
                    </VehicleListWrapper>
                </Box>
            </DataStateHandler>
            <CardHolderPopups />
        </Box>
    )
}
